/**
 * B3 trace headers for distributed tracing
 * Supports both upper-cased (X-B3-TraceId) and lower-cased (x-b3-traceid) variants
 */
export interface TraceHeaders {
  'X-B3-TraceId'?: string;
  'X-B3-SpanId'?: string;
  'X-B3-ParentSpanId'?: string;
  'X-B3-Sampled'?: string;
  'x-b3-traceid'?: string;
  'x-b3-spanid'?: string;
  'x-b3-parentspanid'?: string;
  'x-b3-sampled'?: string;
  'x-request-id'?: string;
}

export interface FetchParams {
  fetchParams?: {
    timeout?: number;
    baseUrl?: string;
  };
  callerId?: string;
  resource?: string;
  traceHeaders?: TraceHeaders;
}

export type ExtendedOptions = RequestInit & {
  vipAddress?: string;
  path?: string;
  timeout?: number;
};
export type ServerErrorDetails = {
  url: string;
  traceId?: string;
  resource?: string;
  requestOptions?: ExtendedOptions;
  requestBody?: BodyInit;
  responseBody?: string;
  responseStatus?: number;
  responseStatusText?: string;
  timeout?: number;
  originalMessage?: string;
};

export enum ErrorMessage {
  GENERIC = 'Service request failed',
  SERVICE_RESPONSE_FAILED = 'Service responded with HTTP code different from 200',
  TIMEOUT = 'Failed due to timeout',
  JSON_PARSE = 'Error converting response to JSON',
}
